module.exports = "/_next/static/videos/01-video-7a6b55037f3f61bb652b15fa8d62e59b.mp4";